export default {
  ADMIN_DUP_USERNAME: 'Nome de usuário já existe',
  DOB_IS_BEFORE_TODAY: 'Data de nascimento deve ser anterior à data atual',
  BANK_CARD_DUP_NUMBER: 'O número do cartão de banco já existe',
  PERMISSION_DENY_ADMIN_ONLY: 'Apenas o administrador do sistema pode executar esta operação',
  PERMISSION_DENY_ADMIN_OR_IT_ONLY:
    'Apenas o administrador do sistema ou o administrador da instituição podem executar esta operação',
  // 5.1 Basic Related
  INVALID_ARGUMENT_BAD_AGENT: 'Informações da conta inválidas [0010]',
  INVALID_ARGUMENT_MIN_DEPOSIT:
    'Deve exceder o limite mínimo de depósito de {minDeposit} dólares (ou valor equivalente em moeda)',
  INVALID_ARGUMENT_MAX_DEPOSIT:
    'Não pode exceder o limite máximo de depósito de {maxDeposit} dólares (ou valor equivalente em moeda)',
  INVALID_ARGUMENT_MIN_WITHDRAWAL:
    'Deve exceder o limite mínimo de saque de {minWithdrawal} dólares (ou valor equivalente em moeda)',
  INVALID_ARGUMENT_MAX_WITHDRAWAL:
    'Não pode exceder o limite máximo de saque de {maxWithdrawal} dólares (ou valor equivalente em moeda)',
  INVALID_ARGUMENT_MORE_THAN_2_SCALES: 'Não pode ter mais de duas casas decimais',
  INVALID_ARGUMENT_RESOURCE_SAVE: 'Parâmetro de salvamento de recurso incorreto',
  INVALID_ARGUMENT_NULL_PASSWORD: 'A senha não pode estar vazia',
  INVALID_ARGUMENT_CONFIRM_PASSWORD: 'Senha de confirmação não corresponde',
  INVALID_ARGUMENT_FORMAT_PASSWORD:
    'Deve conter pelo menos: uma letra maiúscula, uma letra minúscula, um número, e ter um comprimento de 8 a 32 caracteres',
  INVALID_ARGUMENT_PASSWORD_VER_MISMATCH: 'Versão da senha não corresponde',
  INVALID_ARGUMENT_MISSING_PASSWORD_VER_CLAIM: 'Reivindicação de versão de senha ausente',
  INVALID_ARGUMENT_CAN_NOT_DELETE_FOR_VERIFIED: 'Dados verificados não podem ser excluídos',
  INVALID_ARGUMENT_ENTER_BANK_NUM: 'Insira o número da conta bancária',
  INVALID_ARGUMENT_IT_DUP_ID: 'Esta ID da instituição já existe',
  INVALID_ARGUMENT_IT_DUP_APP_KEY: 'Nome de usuário já em uso, por favor, escolha um nome de usuário diferente',
  INVALID_REGISTER: 'Registro proibido',
  INVALID_DATA_USED_CANNOT_BE_DELETED: 'Os dados utilizados não podem ser excluídos',
  INVALID_ARGUMENT_CONFIG_BANK_NOT_NULL: 'As informações do BANCO não podem ficar vazias. Acesse a página de gerenciamento do cartão bancário para adicionar as informações do BANCO',
  // 5.2 Currency Related
  INVALID_ARGUMENT_CURRENCY_BASE_QUOTE_CAN_NOT_BE_THE_SAME: 'As duas moedas não podem ser iguais',
  INVALID_ARGUMENT_FX_RATE_CAN_BE_NULL: 'A taxa de câmbio não pode estar vazia',
  INVALID_ARGUMENT_FX_RATE_MUST_BE_POSITIVE: 'A taxa de câmbio não pode ser zero ou negativa',
  INVALID_ARGUMENT_CURRENCY_DUP_CURRENCY_PAIR: 'Par de moedas idêntico já existe',
  INVALID_ARGUMENT_CURRENCY_AMOUNT_NOT_MATCH: 'Erro na conversão da taxa de câmbio',
  INVALID_ARGUMENT_CURRENCY_FX_RATE_NOT_FOUND: 'Taxa de câmbio para o par de moedas não encontrada',
  INVALID_ARGUMENT_CURRENCY_FX_RATE_TEMPLATE_NOT_FOUND: 'Modelo de taxa de câmbio não encontrado',
  INVALID_ARGUMENT_CURRENCY_INVALID_FOR_THIS_BANK: 'Esta moeda não é suportada pelo banco atual',
  INVALID_ARGUMENT_CURRENCY_INVALID_FOR_THIS_RECEIVE_METHOD: 'Esta moeda não é suportada pelo método de recebimento atual',
  // 5.3 User Related
  INVALID_ARGUMENT_LOGIN_AUTH_BY_GOOGLE:
    'O email já foi autorizado pelo GOOGLE, por favor, faça login com a autorização do GOOGLE',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_FACEBOOK:
    'O email já foi autorizado pelo FACEBOOK, por favor, faça login com a autorização do FACEBOOK',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_APPLE: 'O email já foi autorizado pela APPLE, por favor, faça login com a autorização da APPLE',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_PASSWORD: 'O email foi autorizado para uso com senha, por favor, faça login usando a senha',
  INVALID_ARGUMENT_CUSTOMER_FORMAT: 'O nome de usuário deve ser um endereço de e-mail',
  INVALID_ARGUMENT_CUSTOMER_DUP_USERNAME: 'Nome de usuário já ativado',
  INVALID_ARGUMENT_CUSTOMER_DUP_MOBILE: 'O número de celular já existe',
  INVALID_ARGUMENT_CUSTOMER_NOT_VERIFIED: 'Informações do cliente não verificadas',
  INVALID_ARGUMENT_CUSTOMER_AUTH_NOT_EXIST: 'Informações de autenticação do cliente não existem',
  INVALID_ARGUMENT_CUSTOMER_NOT_EXIST: 'Informações do cliente não existem',
  INVALID_ARGUMENT_EMAIL_CODE_NOT_EXIST: 'Link não existe',
  INVALID_ARGUMENT_EMAIL_CODE_REPEAT: 'Link já não é válido',
  INVALID_ARGUMENT_EMAIL_CODE_TIMEOUT: 'Link já expirou',
  INVALID_ARGUMENT_CUSTOMER_ACCOUNT_NOT_ACTIVATED: 'Conta de negociação do cliente não ativada',
  CUSTOMER_VERIFY_FLOW_NOT_FOUND: 'O fluxo de verificação do cliente não existe',
  CUSTOMER_WITHDRAWAL_FLOW_NOT_FOUND: 'O fluxo de retirada do cliente não existe',
  INVALID_ARGUMENT_CUSTOMER_ID_EXPIRE_LIMIT:
    'A data de validade das informações de identificação deve ter pelo menos {days} dias restantes',
  // 5.4 Business Process Related
  INVALID_ARGUMENT_UNABLE_TO_LOCK_WITHDRAWAL_AMOUNT: 'Não é possível bloquear o valor, atualize e tente novamente',
  INVALID_ARGUMENT_PROCESS_SUBMIT_ILLEGAL_STATUS: 'O status já é "Enviado"',
  INVALID_ARGUMENT_PROCESS_RETRACT_ILLEGAL_STATUS: 'Não pode ser retirado',
  INVALID_ARGUMENT_PROCESS_RETRACT_ILLEGAL_PROCESSED:
    'Status de processamento incorreto: Somente é permitido cancelar quando o status de processamento é "Não Processado" (os dados podem ter sido alterados, refaça a consulta dos dados antes de tentar novamente)',
  INVALID_ARGUMENT_PROCESS_APPROVAL_ILLEGAL_STATUS:
    'Status de aprovação incorreto: Somente é permitido rejeitar ou aprovar quando o status é "Enviado" (os dados podem ter sido alterados, refaça a consulta dos dados antes de tentar novamente)',
  INVALID_ARGUMENT_PROCESS_APPROVAL_ILLEGAL_PROCESSED:
    'Status de processamento incorreto: Somente é permitido rejeitar ou aprovar quando o status de processamento é "Não Processado" (os dados podem ter sido alterados, refaça a consulta dos dados antes de tentar novamente)',
  INVALID_ARGUMENT_PROCESS_APPROVED_FLOW_ILLEGAL_STATUS:
    'Status de aprovação incorreto: Somente é permitido concluir a operação de processamento quando o status de aprovação é "Aprovado" (os dados podem ter sido alterados, refaça a consulta dos dados antes de tentar novamente)',
  INVALID_ARGUMENT_PROCESS_APPROVED_FLOW_ILLEGAL_PROCESSED:
    'Status de processamento incorreto: Somente é permitido concluir a operação de processamento quando o status de processamento é "Não Processado" (os dados podem ter sido alterados, refaça a consulta dos dados antes de tentar novamente)',
  INVALID_ARGUMENT_PROCESS_REJECT_FLOW_ILLEGAL_STATUS:
    'Status de aprovação incorreto: Somente é permitido concluir a operação de processamento quando o status de aprovação é "Rejeitado" (os dados podem ter sido alterados, refaça a consulta dos dados antes de tentar novamente)',
  INVALID_ARGUMENT_PROCESS_ILLEGAL_STATUS: 'Status incorreto',
  // 5.5 KRAMPUS API Related
  INVALID_ARGUMENT_KRAMPUS_API_DUP_LOGIN: 'Nome de usuário do sistema de negociação já existe',
  INVALID_ARGUMENT_KRAMPUS_API_WRONG_KEY_OR_SECRET: 'Nome de usuário/senha do sistema de negociação incorretos',
  INVALID_ARGUMENT_KRAMPUS_API_LOGIN_FAILED: 'Falha no login do sistema de negociação',
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_DUP_LOGIN: 'Nome de usuário do sistema de negociação de demonstração já existe',
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_WRONG_KEY_OR_SECRET:
    'Nome de usuário/senha do sistema de negociação de demonstração incorretos',
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_LOGIN_FAILED: 'Falha no login do sistema de negociação de demonstração',
  INVALID_ARGUMENT_KRAMPUS_API_SYNC_IT_FAILED:
    'Falha na sincronização das informações da instituição, instituição com ID {itId} não encontrada, verifique as permissões',
  INVALID_ARGUMENT_KRAMPUS_API_INVOKE_ERROR: 'Falha na chamada do sistema de negociação',
  INVALID_ARGUMENT_KRAMPUS_API_INSUFFICIENT_FUNDS: 'Saldo da conta insuficiente',
  INVALID_ARGUMENT_KRAMPUS_API_PASSWORD_IS_EMPTY: 'Senha está vazia, defina uma senha primeiro',
  INVALID_ARGUMENT_KRAMPUS_API_TOKEN_FAILED: 'Login expirou, faça o login novamente',
  // Token Related
  INVALID_ARGUMENT_INVALID_ISSUER_FORMAT: 'Formato de emissor inválido',
  INVALID_ARGUMENT_MISSING_LOGIN_CODE: 'Código de login ausente',
  INVALID_ARGUMENT_CUSTOMER_NOT_FOUND: 'Cliente não encontrado',
  INVALID_ARGUMENT_MISSING_PASSWORD_TIME_CLAIM: 'Declaração de tempo da senha ausente',
  INVALID_ARGUMENT_PASSWORD_TIME_MISMATCH: 'Tempo da senha não corresponde',
  INVALID_ARGUMENT_TOKEN_EXPIRED: 'Token expirado',
  // 5.6 METHOD Related
  INVALID_ARGUMENT_METHOD_BANK_USDT_INVALID: 'A moeda de depósito de banco não pode ser USDT',
  INVALID_ARGUMENT_METHOD_BANK_BANK_CAN_NOT_NULL: 'Selecione um banco',
  INVALID_ARGUMENT_METHOD_BANK_ACCOUNT_NAME_CAN_NOT_EMPTY: 'O nome da conta bancária não pode estar vazio',
  INVALID_ARGUMENT_METHOD_BANK_ACCOUNT_NUMBER_CAN_NOT_EMPTY: 'O número da conta bancária não pode estar vazio',
  INVALID_ARGUMENT_METHOD_USDT_USDT_ONLY: 'A moeda de depósito de USDT deve ser USDT',
  INVALID_ARGUMENT_METHOD_USDT_AT_LEAST_ONE_IS_REQUIRED: 'Pelo menos um endereço ou código QR deve ser preenchido',
  INVALID_ARGUMENT_METHOD_USDT_CRYPTO_NETWORK_REQUIRED: 'A rede de depósito de USDT deve ser preenchida',
  INVALID_ARGUMENT_METHOD_WECHAT_CNY_ONLY: 'A moeda de depósito do WeChat deve ser CNY',
  INVALID_ARGUMENT_METHOD_REQUIRE_QR_CODE: 'O método de depósito atual requer o envio de um código QR',
  // 5.7 Deposit/Withdrawal Related
  INVALID_ARGUMENT_IT_TRANSFER_CONFIG_ERROR: 'Erro na configuração do canal',
  INVALID_ARGUMENT_IT_TRANSFER_CAN_NOT_BE_NULL: 'A transferência da instituição não pode estar vazia',
  INVALID_ARGUMENT_IT_TRANSFER_AMOUNT_CAN_NOT_BE_NULL: 'O valor da transferência da instituição não pode estar vazio',
  INVALID_ARGUMENT_IT_TRANSFER_RECEIVE_CAN_NOT_BE_NULL: 'A conta da transferência da instituição não pode estar vazia',
  INVALID_ARGUMENT_DEPOSIT_AMOUNT_TRANSFER_AMOUNT_NOT_MATCH: 'O valor do depósito não corresponde ao valor da transferência',
  INVALID_ARGUMENT_PAYMENT_SAME_TYPE_PAYMENT_CHANNEL_ONLY_ONE: 'Apenas um canal de pagamento do mesmo tipo pode ser selecionado',
  INVALID_ARGUMENT_DUPLICATE_PAYMENT_CHANNEL_TYPE: 'Apenas um gateway de pagamento do mesmo tipo pode ser selecionado',
  INVALID_ARGUMENT_PAYMENT_INVOKE_ERROR: 'Falha na chamada da API de pagamento',
  INVALID_ARGUMENT_PAYMENT_INVOKE_PARAM_ERROR: 'Erro nos parâmetros da chamada de pagamento',
  INVALID_ARGUMENT_TRANSACTION_AMOUNT: 'Depósito/Saque não atende aos requisitos de valor',
  INVALID_ARGUMENT_CLOSE_ACCOUNT_ERROR: 'Erro ao encerrar a conta, a posição deve estar zerada e o saldo deve ser zero',
  INVALID_ARGUMENT_CONFIG_PIX_NOT_NULL: 'As informações de PIX não podem ficar em branco. Atualize seus dados de PIX na página de gerenciamento de cartões bancários.',
  INVALID_ARGUMENT_CONFIG_IFSC_NOT_NULL: 'As informações de IFSC não podem ficar em branco. Atualize seus dados de IFSC na página de gerenciamento de cartões bancários.',
  // 6. Operação não suportada
  UNSUPPORTED_OPERATION_NO_IT_RECEIVE_FOUND: 'Esta instituição não suporta depósitos nesta moeda',
  // 7. Verificação de e-mail
  THIRD_PARTY_AUTH_USER_CANNOT_RESET_PASSWORD: 'Usuários com autenticação de terceiros não podem redefinir a senha',
  INVALID_THIRD_PARTY_ACCOUNT_UNBINDING_FAILED: 'Falha ao desvincular a conta de terceiros',
  THIRD_PARTY_AUTH_USER_CANNOT_ACTIVE_EMAIL: 'Usuários com autenticação de terceiros não precisam ativar a conta',
  INVALID_ACCOUNT_ALREADY_EXISTS_AND_LOCKED: 'Esta conta já existe e está bloqueada',
  INVALID_EMAIL_CHECK_INVALID_USER: 'Usuário inválido',
  INVALID_EMAIL_CHECK_USER_NOT_EXIST: 'Usuário não encontrado',
  INVALID_EMAIL_CHECK_EMAIL_VERIFIED: 'O e-mail já foi verificado',
  INVALID_EMAIL_CHECK_EMAIL_NOT_VERIFIED: 'O e-mail não foi verificado',
  INVALID_EMAIL_CHECK_INVALID_REQUEST_PARAMETERS: 'Operação falhou, solicitação expirada',
  INVALID_EMAIL_CHECK_REPEATED_REQUEST: 'Solicitação repetida, por favor, tente novamente mais tarde',
  INVALID_ARGUMENT_INVALID_PROVIDERTYPE: 'Tipo de login de terceiros inválido',
  INVALID_ARGUMENT_ORIGINAL_PASSWORD_MISMATCH: 'Senha antiga não corresponde',
  INVALID_ARGUMENT_NEW_PASSWORD_SAME_AS_OLD: 'Nova senha não pode ser igual à senha antiga',
  INVALID_ARGUMENT_EXCLUSIVE_AGENT_LINK: 'Não é possível se registrar, este link pertence a um agente exclusivo, registro múltiplo é proibido',
  INVALID_ARGUMENT_DUPLICATE_WITHDRAWAL: 'Retire o pedido e retire o dinheiro novamente ou aguarde a revisão do pedido e inicie novamente.',
  // Registro
  REGISTER_DUP_USERNAME: 'Este nome de usuário já está registrado',
  REGISTER_DUP_MOBILE: 'Este número de celular já está registrado',
  USERNAME_WRONG_FORMAT: 'Formato de nome de usuário incorreto',
  MOBILE_WRONG_FORMAT: 'Formato de número de celular incorreto',
  ID_CARD_ID_WRONG_FORMAT: 'Formato de número de identidade incorreto',

  // Login
  LOGIN_FAILED: 'Falha no login, nome de usuário ou senha incorretos',
  LOGIN_NOT_ENABLED: 'A conta foi desativada',
  LOGIN_LOCKED: 'A conta está bloqueada',
  // Senha
  PASSWORD_WRONG: 'Senha incorreta',
  PASSWORD_WRONG_FORMAT: 'A senha deve ter entre 6 e 16 caracteres e não pode conter espaços',
  PASSWORD_WRONG_TIME_LEFT: 'Senha incorreta, {timeLeft} tentativas restantes',
  PASSWORD_CONFIRM_NOT_MATCH: 'Senha de confirmação não corresponde',
  PASSWORD_WRONG_AND_LOCK: 'Senha incorreta {failedAttempt} vezes consecutivas, a conta está bloqueada',
  PASSWORD_NULL: 'A senha não pode estar vazia',
  CONFIRM_PASSWORD_NOT_MATCH: 'Senha de confirmação não corresponde',
  // Permissão
  PERMISSION_DENY: 'Você não tem permissão para acessar',
  // Token JWT
  JWT_INVALID_TOKEN: 'Login expirou, faça o login novamente',
  JWT_VERSION_NOT_MATCHED: 'Versão não corresponde',
  // Código de Verificação de SMS
  SMS_VERIFY_CODE_NOT_MATCH: 'Código de verificação não corresponde',
  CAPTCHA_VERIFY_CODE_NOT_MATCH: 'Código de verificação não corresponde',
  // Validação de Parâmetros

  INVALID_ARGUMENT: 'Parâmetro incorreto',
  INVALID_ARGUMENT_NULL_POINT: 'Parâmetro incorreto: o parâmetro não pode estar vazio',
  // Outros
  DATA_NOT_FOUND: 'Dados não encontrados',
  STALE_VERSION: 'Os dados foram alterados, atualize e tente novamente',
  INVALID_STATE: 'Estado inválido, os dados podem ter sido alterados',
  INVALID_VALUE: 'Conteúdo do parâmetro incorreto',
  INVALID_FORMAT: 'Formato de parâmetro incorreto',
  INTERNAL_ERROR: 'Erro interno, entre em contato com o administrador',
  MULTI_ARGS_TEST: 'arg1 {arg1}, arg2 {arg2}, arg3 {arg3}',
  INVALID_ARGUMENT_NOT_BLANK: 'Não pode estar em branco',

  // Terceiros
  access_denied: 'Acesso negado',
  invalid_token_response: 'Resposta de token inválida',
  authorization_request_not_found: 'Solicitação de autorização não encontrada',

  INVALID_ARGUMENT_CUSTOMER_PHONE_FORMAT: 'O nome de usuário deve ser um número de telefone.',
  INVALID_EMAIL_CHECK_CONTACT_VERIFIED: 'Conta verificada.',
  INVALID_EMAIL_CHECK_CONTACT_NOT_VERIFIED: 'Conta não verificada.',
  INVALID_ARGUMENT_SMS_CODE_TIMEOUT: 'O código de verificação expirou.',
  INVALID_ARGUMENT_SMS_CODE_ERROR: 'Código de verificação incorreto.',
  INVALID_ARGUMENT_SMS_RATE_LIMIT: 'Limite de frequência de envio de SMS excedido, por favor tente novamente mais tarde.',
};
